import { render, staticRenderFns } from "./OnBoardingPhasesCycle.vue?vue&type=template&id=310e491f&"
import script from "./OnBoardingPhasesCycle.vue?vue&type=script&lang=js&"
export * from "./OnBoardingPhasesCycle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports